import { ReactNode, MouseEvent, FC } from 'react'
import { noop } from 'lodash'
import Button from '../Button'
import HorizontalSpinner from '../HorizontalSpinner'

type SpinnerButtonProps = {
  disabled?: boolean
  name?: string
  type?: 'button' | 'submit' | 'reset'
  className?: string
  spinWhenDisabled?: boolean
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
  children?: ReactNode
}

const SpinnerButton: FC<SpinnerButtonProps> = ({
  disabled = false,
  name = '',
  type = 'button',
  className = '',
  spinWhenDisabled = true,
  onClick = noop,
  children,
}) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    onClick(event)
  }

  const getSpinnerContent = () => <HorizontalSpinner key="spinner" />

  const content = disabled && spinWhenDisabled ? getSpinnerContent() : children

  return (
    <Button name={name} type={type} className={className || undefined} disabled={disabled} onClick={handleClick}>
      {content}
    </Button>
  )
}

export default SpinnerButton
